import {
  PrimaryLightTextColor,
  PrimaryTextColor,
  boldFont,
  getRelativeFontSize,
  regularFont,
} from "../../../../utils/styles";

const LeaveApplyFormStyles = {
  leaveDetailsWrapper: {},
  pageInfoHeader: {
    // position: "absolute",
    // left: "130px",
    // top: "30px",
  },

  Heading: {
    ...boldFont,
    fontSize: getRelativeFontSize(10),
  },

  text: {
    ...regularFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-2),
  },

  header: {
    paddingBottom: "30px ",
    marginTop: 5,
  },
  pageHeading: {
    fontSize: getRelativeFontSize(2),
    ...boldFont,
    color: PrimaryTextColor,
  },
  pageText: {
    ...regularFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-2),
  },

  label: {
    ...regularFont,
    fontSize: getRelativeFontSize(),
    wordSpacing: "2px",
    color: PrimaryTextColor,
  },

  autocomplateStyle: {
    width: '100%',
    background: '#fffff',
    "& .MuiInputBase-input": {
      color: PrimaryTextColor,
      ...regularFont,
      fontSize: getRelativeFontSize(2),
      "&::placeholder": {
        ...regularFont,
        fontSize: getRelativeFontSize(-1),
        color: PrimaryLightTextColor,
      },
    },
    '&  .MuiOutlinedInput-root': {
      padding: '4px 9px',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
      '&.Mui-focused fieldset': {
        borderColor: '#E7E7EA',
      },
      "&:hover fieldset": {
        borderColor: "#E7E7EA",
      },
    },
    '& .css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
      borderColor: '#E7E7EA',
    },
  },

  leaveLabel: {
    ...regularFont,
  },

  CheckLabel: {
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(),
    ...regularFont,
  },

  buttonWraaper: {
    marginLeft: "40px",
    marginTop  :"20px",
    "& button ": {
      width: "150px",
    },
  },

  submitStyle: {
    width: "150px",
  },

  checkBoxWarapper: {
    display: "flex",
    marginTop: "10px",
  },

  error :  {
    color: "#d32f2f",
    fontSize: getRelativeFontSize(),
    ...regularFont,
    marginLeft: "5px",
    marginBottom: "5px",

  }
};

export default LeaveApplyFormStyles;
